<template>
  <v-app id="app" :class="isAdmin ? 'ThemeAdmin' : 'ThemeNormal'">
    <router-view />
    <!-- global dialog -->
    <v-dialog
      v-model="dialog.show"
      persistent
      :max-width="dialog.multiLine ? 800 : 600"
      content-class="common-dialog"
    >
      <v-card>
        <v-container class="pa-8">
          <v-row justify="center" class="mt-8 nocenter-icon">
            <v-icon
              :color="dialog.iconColor ? dialog.iconColor : 'secondary'"
              class="common-dialog-icon pr-2"
              >{{ dialog.icon }}</v-icon
            >
            <div class="medium-small-gray-text ml-2 dialog-title">
              <template v-if="!dialog.multiLine">
                {{ dialog.text }}
              </template>
              <template v-else>
                <p v-for="(item, index) in dialog.multiLineTexts" :key="index">
                  {{ item }}
                </p>
              </template>
            </div>
          </v-row>
          <v-row
            v-if="dialog.content"
            class="mt-8 dialog-content"
            justify="center"
            v-html="dialog.content"
          ></v-row>
          <v-row justify="center" :class="!dialog.multiLine ? 'mt-8' : 'mt-2'">
            <v-btn
              large
              class="button-size close-g-btn ma-8"
              dark
              @click="closeDialog"
            >
              閉じる
            </v-btn>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- save dialog -->
    <v-dialog
      v-model="saveDialog.show"
      persistent
      :max-width="saveDialog.multiLine ? 800 : 600"
      content-class="save-dialog"
    >
      <v-card>
        <v-container class="pa-8">
          <v-row justify="center" class="mt-8">
            <v-icon
              size="30"
              :color="saveDialog.iconColor ? saveDialog.iconColor : 'secondary'"
              class="save-dialog-icon"
              >{{ saveDialog.icon }}</v-icon
            >
            <div class="medium-small-gray-text ml-2 dialog-title">
              <template v-if="!saveDialog.multiLine">
                {{ saveDialog.text }}
              </template>
              <template v-else>
                <p
                  v-for="(item, index) in saveDialog.multiLineTexts"
                  :key="index"
                >
                  {{ item }}
                </p>
              </template>
            </div>
          </v-row>
          <v-row
            v-if="dialog.content"
            class="mt-8 dialog-content"
            justify="center"
            v-html="saveDialog.content"
          ></v-row>
          <v-row
            justify="center"
            :class="!saveDialog.multiLine ? 'mt-8' : 'mt-2'"
          >
            <v-btn
              large
              class="button-size close-s-btn ma-8"
              dark
              @click="closeSaveDialog"
            >
              {{ saveDialog.closebtntext ? saveDialog.closebtntext : '閉じる' }}
            </v-btn>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <ModalIdle v-if="isIdle"/>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import ModalIdle from "@/components/ModalIdle";
export default {
  name: 'App',
  components: {
    ModalIdle
  },
  computed: {
    isAdmin() {
      return this.$route.path.startsWith("/admin");
    },
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
    ...mapGetters(["dialog", "saveDialog"]),
  },
  data: () => ({
    showDialog: false,
    // admin かどうかで切り替えるテーマ色
    themes: [
      {
        name: "ThemeAdmin",
        light: {
          primary: "#F4C500",
          secondary: "#EB6B35",
          accent: "#384763",
          error: "#f03748",
          warning: "#ff9800",
          info: "#673ab7",
          success: "#1db78b",
          primary_label: "#9ad97f",
          white: "#ffffff",
          button_green: "#63C8AB"
        }
      },
      {
        name: "ThemeNormal",
        light: {
          primary: "#043099",
          secondary: "#e2f7fa",
          accent: "#606060",
          error: "#f03748",
          warning: "#ff9800",
          info: "#03a9f4",
          success: "#3f51b5",
          primary_label: "#9ad97f",
          white: "#ffffff",
          button_green: "#63C8AB"
        }
      }
    ]
  }),
  methods: {
    closeDialog() {
      this.dialog.show = false;
      if (this.dialog.closeEvent) {
        this.dialog.closeEvent();
      }
    },
    closeSaveDialog() {
      this.saveDialog.show = false;
      if (this.saveDialog.closeEvent) {
        this.saveDialog.closeEvent();
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.save-dialog {
  .dialog-title {
    font-size: $size-page-title;
    color: $color-title;
  }
  .dialog-content {
    font-size: $size-normal;
    color: $color-text;
  }
  .close-s-btn {
    background-color: #1947a3;
  }
}
</style>